


import React, { PropsWithChildren, useEffect, useState } from 'react';
import { BrowserRouter, Navigate, Outlet, Route, Routes } from 'react-router-dom';
import useRoutes from './router/routes';
import BlankLayout from './components/Layouts/BlankLayout';
import DefaultLayout from './components/Layouts/DefaultLayout';
function App({ children }: PropsWithChildren) {
    const routes = useRoutes();
    const [topbarType, setTopbarType] = useState('');
    const app_type = window.location.pathname.split('/')[1];
    const domain = 'apps.alltheapps.io';

    interface Route {
        guard?: {
            valid: boolean;
            redirect: string;
            state?: Record<string, any>;
        };
        path?: string;
        layout?: string;
        element?: React.ReactNode;
    }
    useEffect(() => {
        if (window.location.pathname.split('/')[1] == 'app') {
            setTopbarType('app');
        } else {
            setTopbarType('main');
        }
    }, [window.location.pathname]);

    const getRoutes = (allRoutes: Route[]): React.ReactNode[] => {
        return allRoutes.map((route) => {
            if (route.path) {
                return <Route key={route.path} path={route.path} element={route.layout === 'blank' ? <BlankLayout>{route.element}</BlankLayout> : <DefaultLayout>{route.element}</DefaultLayout>} />;
            }

            return null;
        });
    };

    return (
        <React.Fragment>
            <BrowserRouter>
                {/* {domain != 'apps.alltheapps.io' && domain != 'localhost' && <AppHeader />} */}

                <div>
                    <Routes>
                        <Route path="*" element={<Navigate to="/" />} />
                        {getRoutes(routes)}
                    </Routes>
                </div>
            </BrowserRouter>
        </React.Fragment>
    );
}

export default App;
